export const LIVE_LOCATION_MAX_AGE_MS = 2 * 60 * 1000;

export function isUsableLatLng(lat, lng) {
  const latNum = Number(lat);
  const lngNum = Number(lng);
  return (
    Number.isFinite(latNum) &&
    Number.isFinite(lngNum) &&
    latNum >= -90 &&
    latNum <= 90 &&
    lngNum >= -180 &&
    lngNum <= 180 &&
    !(Math.abs(latNum) < 0.0001 && Math.abs(lngNum) < 0.0001)
  );
}

export function isFreshLocation(updatedAt, now = Date.now()) {
  if (!updatedAt) return false;
  const timestamp = updatedAt instanceof Date ? updatedAt.getTime() : new Date(updatedAt).getTime();
  if (!Number.isFinite(timestamp)) return false;
  return timestamp <= now + 60_000 && now - timestamp <= LIVE_LOCATION_MAX_AGE_MS;
}
